import {
  useTheme,
  Stack,
  styled,
  Box,
  Paper,
  Button,
  useMediaQuery,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Alert,
  Snackbar,
  Zoom,
} from "@mui/material";

import useStyles from "./styles";
import Filters from "../../componentes/easyLogs/filters";
import { useEffect, useRef, useState } from "react";
import api from "../../services/api";
import { ReactComponent as LogoEasyLog } from "../../assets/logosSvg/logoEasyLog.svg";
import LogoEasyLogSVG from "../../assets/logoEasyLog.png";
import {
  FileDownloadOutlined,
  LocalPrintshopOutlined,
  MoreVertOutlined,
} from "@mui/icons-material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Link, Outlet } from "react-router-dom";

export default function EasyLog() {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [controller, setController] = useState(null);
  const [snackbar, setSnackbar] = useState(null);
  const [typeDB, setTypeDB] = useState("bpa");
  const [havelinkDB, setHaveLinkDB] = useState(null);
  const [dataFilter, setDataFilter] = useState(null);
  const [rowsEvents, setRowsEvents] = useState([]);
  const [rowsAloc, setRowsAloc] = useState([]);
  const [portsTime, setPortsTime] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [loadingAloc, setLoadingAloc] = useState(false);
  const [loadingVarPort, setLoadingVarPort] = useState(false);
  const [loadingSetting, setLoadingSettings] = useState(false);
  const [erpStatus, setErpStatus] = useState(false);
  const [timeZone, setTimeZone] = useState("America/Sao_Paulo");

  const eventos = { 1: "ADD", 2: "DEL" };
  const protocolos = { 1: "ICMP", 6: "TCP", 17: "UDP", 255: "ALL" };
  const filterRef = useRef();
  const up600 = useMediaQuery(theme.breakpoints.up("sm"));
  const up400 = useMediaQuery(theme.breakpoints.up("xsm"));
  const upMD = useMediaQuery(theme.breakpoints.up("md"));

  const easyLogsLogo =
    theme.palette.mode === "dark"
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_LOGS_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_LOGS_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_LOGS_URL || ""}`;

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .no-rows-primary": {
      fill: theme.palette.mode === "light" ? "#3D4751" : "#3D4751",
      ...theme.applyStyles("light", {
        fill: "#AEB8C2",
      }),
    },
    "& .no-rows-secondary": {
      fill: theme.palette.mode === "light" ? "#1D2126" : "#3D4751",
      ...theme.applyStyles("light", {
        fill: "#E8EAED",
      }),
    },
  }));

  const ButtonExports = ({ apiRef, columns }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const handleExport = ({ apiRef }) => {
      apiRef?.current?.exportDataAsCsv(); // Exportação nativa do DataGrid
    };
    const handlePrint = ({ apiRef, columns }) => {
      // Obter TODAS as linhas diretamente do estado do grid
      const allRows = apiRef.current.getSortedRows();

      // Adicionar coluna CPF/CNPJ apenas no PDF quando ERP está habilitado
      const pdfCols = erpStatus
        ? [...columns, { field: "CPF/CNPJ", headerName: "CPF/CNPJ" }]
        : columns;

      // Mapear as colunas e linhas corretamente
      const pdfColumns = pdfCols.map((col) => col.headerName);
      const pdfRows = allRows.map((row) =>
        pdfCols.map((col) => {
          let value = row[col.field] ?? "";
          if (col.field === "Protocolo" && protocolos[value]) {
            return protocolos[value];
          }
          if (col.field === "Evento" && eventos[value]) {
            return eventos[value];
          }
          return value;
        })
      );

      // Criar PDF
      const doc = new jsPDF();

      autoTable(doc, {
        head: [pdfColumns],
        body: pdfRows,
        styles: {
          fontSize: 8,
          cellPadding: 2,
        },
        theme: "grid",
        headStyles: {
          fillColor: theme.palette.easyLog.primary,
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // cor de fundo das linhas alternadas
        },
        margin: { top: 25, bottom: 25 },
        willDrawPage: (data) => {
          doc.addImage(
            LogoEasyLogSVG,
            "PNG",
            data.settings.margin.right,
            data.settings.margin.top - 12,
            36,
            8
          );
        },
        didDrawPage: (data) => {
          const pageHeight = doc.internal.pageSize.height;
          const marginRight = doc.internal.pageSize.width - 14;
          const marginLeft = data.settings.margin.left;

          doc.setDrawColor(0, 0, 0); // Cor da linha (preto)
          doc.setLineWidth(0.1); // Largura da linha
          doc.line(marginLeft, pageHeight - 15, marginRight, pageHeight - 15); // Linha horizontal
          // Exibe o número da página atual no rodapé
          doc.setFontSize(8);

          doc.text(`${data.pageNumber}`, marginRight - 3, pageHeight - 10);
          doc.text(
            `Made by EasyLogs - MW Solucoes LTDA. Emitido em ${new Date().toLocaleString()}`,
            marginLeft + 1,
            pageHeight - 10
          );
        },
      });

      // Salvar o PDF
      doc.save("todas-linhas.pdf");
    };
    if (up400)
      return (
        <>
          {up600 ? (
            <Button
              sx={styles.buttomDataGrid}
              onClick={() => handleExport({ apiRef })}
              startIcon={<FileDownloadOutlined />}
            >
              Exportar
            </Button>
          ) : (
            <IconButton onClick={() => handleExport({ apiRef })}>
              <FileDownloadOutlined />
            </IconButton>
          )}{" "}
          {up600 ? (
            <Button
              sx={styles.buttomDataGrid}
              onClick={() => handlePrint({ apiRef, columns })}
              startIcon={<LocalPrintshopOutlined />}
            >
              Imprimir
            </Button>
          ) : (
            <IconButton onClick={() => handlePrint({ apiRef, columns })}>
              <LocalPrintshopOutlined />
            </IconButton>
          )}
        </>
      );
    else {
      return (
        <>
          <IconButton onClick={handleClick}>
            <MoreVertOutlined />
          </IconButton>{" "}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={() => handlePrint(apiRef)}>
              <ListItemIcon>
                <LocalPrintshopOutlined />
              </ListItemIcon>
              Printar
            </MenuItem>
            <MenuItem onClick={() => handleExport(apiRef)}>
              <ListItemIcon>
                <FileDownloadOutlined />
              </ListItemIcon>
              Exportar
            </MenuItem>
          </Menu>
        </>
      );
    }
  };

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          width={96}
          viewBox="0 0 452 257"
          aria-hidden
          focusable="false"
        >
          <path
            className="no-rows-primary"
            d="M348 69c-46.392 0-84 37.608-84 84s37.608 84 84 84 84-37.608 84-84-37.608-84-84-84Zm-104 84c0-57.438 46.562-104 104-104s104 46.562 104 104-46.562 104-104 104-104-46.562-104-104Z"
          />
          <path
            className="no-rows-primary"
            d="M308.929 113.929c3.905-3.905 10.237-3.905 14.142 0l63.64 63.64c3.905 3.905 3.905 10.236 0 14.142-3.906 3.905-10.237 3.905-14.142 0l-63.64-63.64c-3.905-3.905-3.905-10.237 0-14.142Z"
          />
          <path
            className="no-rows-primary"
            d="M308.929 191.711c-3.905-3.906-3.905-10.237 0-14.142l63.64-63.64c3.905-3.905 10.236-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142l-63.64 63.64c-3.905 3.905-10.237 3.905-14.142 0Z"
          />
          <path
            className="no-rows-secondary"
            d="M0 10C0 4.477 4.477 0 10 0h380c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 20 0 15.523 0 10ZM0 59c0-5.523 4.477-10 10-10h231c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 69 0 64.523 0 59ZM0 106c0-5.523 4.477-10 10-10h203c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 153c0-5.523 4.477-10 10-10h195.5c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 200c0-5.523 4.477-10 10-10h203c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 247c0-5.523 4.477-10 10-10h231c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10Z"
          />
        </svg>
        <Box sx={{ mt: 2 }}>Sem Dados</Box>
      </StyledGridOverlay>
    );
  }
  const filtersTimeNow = () => {
    return {
      timeInit: filterRef?.current
        ?.getTimeFilter()
        .filterDateInicial?.tz(timeZone),

      timeEnd: filterRef?.current
        ?.getTimeFilter()
        .filterDateFinal?.tz(timeZone),
    };
  };
  const getLogsClienteHandle = async (filters) => {
    if (!filters) {
      filters = {
        time: filtersTimeNow(),
        port: null,
        ip: null,
        event: null,
        protocol: null,
      };
    }
    try {
      setLoadingEvents(true);
      const response = await api.post(
        "/easyLog/getEventsClient",
        {
          filters,
        },
        { signal: controller.signal }
      );
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os logs",
          severity: "error",
        });
      } else {
        if (response.data) {
          setRowsEvents(response.data);
        }
      }
      setLoadingEvents(false);
    } catch (error) {
      setLoadingEvents(false);
      if (error?.message == "canceled") return;
      setSnackbar({
        children: "Error: Não foi possível realizar conexão com o servidor",
        severity: "error",
      });
    }
  };
  const getAlocationsClienteHandle = async (filters) => {
    if (!filters) {
      filters = {
        time: filtersTimeNow(),
        port: null,
        ip: null,
        event: null,
        protocol: null,
      };
    }
    try {
      setLoadingAloc(true);
      const response = await api.post(
        "/easyLog/getAlocClient",
        {
          filters,
        },
        { signal: controller.signal }
      );
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os logs",
          severity: "error",
        });
      } else {
        if (response.data) {
          setRowsAloc(response.data);
        }
      }
      setLoadingAloc(false);
    } catch (error) {
      setLoadingAloc(false);
      if (error?.message == "canceled") return;
      setSnackbar({
        children: "Error: Não foi possível realizar conexão com o servidor",
        severity: "error",
      });
    }
  };
  const getCountPortsHandle = async (filters) => {
    if (!filters) {
      filters = {
        time: filtersTimeNow(),
        port: null,
        ip: null,
      };
    }
    try {
      setLoadingVarPort(true);
      const response = await api.post(
        "/easyLog/getPortsTimeClient",
        {
          filters,
        },
        { signal: controller.signal }
      );
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os logs",
          severity: "error",
        });
      } else {
        if (response.data) {
          setPortsTime(response.data);
        }
      }
      setLoadingVarPort(false);
    } catch (error) {
      setLoadingVarPort(false);
      if (error?.message == "canceled") return;
      setSnackbar({
        children: "Error: Não foi possível realizar conexão com o servidor",
        severity: "error",
      });
    }
  };
  const getDataFilter = async (filters) => {
    if (!filters) {
      filters = {
        time: filtersTimeNow(),
      };
    }
    try {
      //setLoadingAloc(true);
      const response = await api.post(
        "/easyLog/getDataFilter",
        {
          filters,
        },
        { signal: controller.signal }
      );
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os logs",
          severity: "error",
        });
      } else {
        if (response.data) {
          setDataFilter(response.data);
        }
      }
      //setLoadingAloc(false);
    } catch (error) {
      if (error?.message == "canceled") return;
      setSnackbar({
        children: "Error: Não foi possível realizar conexão com o servidor",
        severity: "error",
      });
    }
  };
  async function handleGetSettings(controller) {
    try {
      setLoadingSettings(true);
      const response = await api.post(
        "/settings/find",
        {
          product: "easylogs",
        },
        { signal: controller.signal }
      );
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          setTypeDB(response.data?.configuracoes?.typeBpa ? "bpa" : "nat");
          setTimeZone(
            response.data?.configuracoes?.timeZone || "America/Sao_Paulo"
          );
          setErpStatus(response.data?.configuracoes?.erpStatus);

          const link = response.data?.configuracoes?.linkBanco;
          if (!link || link == "") setHaveLinkDB(false);
          else setHaveLinkDB(true);
        }
      }
      setLoadingSettings(false);
    } catch (error) {
      setLoadingSettings(false);
      if (error?.message == "canceled") return;
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  ///easyLog/getERPinfo
  const updateController = () => {
    if (controller) {
      controller.abort();
    }
    const newController = new AbortController();
    setController(newController);
  };

  useEffect(() => {
    const controller = new AbortController();
    setController(controller);
    handleGetSettings(controller);
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    if (!havelinkDB) return;
    Promise.all([
      getLogsClienteHandle(),
      getAlocationsClienteHandle(),
      getCountPortsHandle(),
      getDataFilter(),
    ]);
  }, [havelinkDB]);

  return (
    <>
      <Stack gap={upMD ? 2 : 1.5} direction={"column"}>
        {havelinkDB == false && (
          <Alert severity="warning">
            O link do banco de dados do EasyLogs ainda não foi informado! Acesse
            as{" "}
            <Link
              style={{ color: "inherit", fontWeight: 500 }}
              to={"/configuracoes/easylogs"}
            >
              configurações
            </Link>{" "}
            do sistema para configurá-lo.
          </Alert>
        )}

        <Paper sx={styles.paperTitlePage}>
          {easyLogsLogo ? (
            <img
              src={easyLogsLogo}
              style={{ width: upMD ? "200px" : "150px", maxHeight: "52px" }}
            />
          ) : (
            <LogoEasyLog
              width={upMD ? "200px" : "150px"}
              style={{
                fill: theme.palette.text.primary,
              }}
            />
          )}
        </Paper>
        <Filters
          loading={loadingVarPort || loadingAloc || loadingEvents}
          updateController={updateController}
          timeZone={timeZone}
          data={dataFilter}
          protocolos={protocolos}
          eventos={eventos}
          ref={filterRef}
          getAlocationsClienteHandle={getAlocationsClienteHandle}
          getLogsClienteHandle={getLogsClienteHandle}
          getCountPortsHandle={getCountPortsHandle}
          getDataFilter={getDataFilter}
        />
        <Box spacing={2} sx={styles.container}>
          <Outlet
            context={{
              CustomNoRowsOverlay,
              ButtonExports,
              loadingEvents,
              loadingAloc,
              loadingVarPort,
              rowsEvents,
              rowsAloc,
              eventos,
              protocolos,
              portsTime,
              typeDB,
              erpStatus,
            }}
          />
        </Box>
      </Stack>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
